import { SchemaFormApi, SchemaFormOptions } from "../shared/types";
import useForm from "./use-form";
import { getDefaultValueFromSchema } from "../shared/utils";
import { z } from "zod/v4";

export default function useSchemaForm<TSchema extends z.ZodType>({
    schema,
    ...props
}: SchemaFormOptions<TSchema>): SchemaFormApi<TSchema> {
    return useForm({
        ...props,
        onSubmit: async ({ value, formApi, meta }) => {
            props.onSubmit && await props.onSubmit({
                value: schema.parse(value),
                formApi,
                meta,
            })
        },
        defaultValues: {
            ...getDefaultValueFromSchema(schema),
            ...props.defaultValues
        },
        validators: {
            onSubmit: schema,
            ...props.validators
        }
    })
}